import { writable } from "svelte/store";

export const pageTitleStore = writable({
  pathname: "",
  section: "",
  breadcrumb: "",
});
